import SendingInvoiceToClient from './SendingInvoiceToClient.component';

export default SendingInvoiceToClient;